import {
  Theme,
  Switch as MuiSwitch,
  withStyles,
  createStyles,
  SwitchClassKey,
  SwitchProps as MuiSwitchProps,
} from "@material-ui/core";

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}
type Props = {
  classes: Styles;
} & SwitchControlProps;

export type SwitchControlProps = MuiSwitchProps;

export const SwitchControl = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 46,
      height: 24,
      padding: 8,
      overflow: "visible",
      marginRight: 4,
    },
    switchBase: {
      padding: 2,
      margin: 1,
      transform: "translateX(2px)",
      "&$checked": {
        transform: "translateX(20px)",
        "& + $track": {
          backgroundColor: theme.palette.blueGrey.main,
        },
      },
    },
    track: {
      backgroundColor: theme.palette.blueGrey.main,
    },
    thumb: {
      width: 18,
      height: 18,
      boxShadow: "0 4px 8px 0 rgba(32, 37, 43, 0.12), 0 0 1px 0 rgba(32, 37, 43, 0.1)",
    },
    checked: {},
  }),
)(({ classes, color = "primary", ...rest }: Props) => (
  <MuiSwitch
    aria-label="switch"
    color={color}
    {...rest}
    focusVisibleClassName={classes.focusVisible}
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
      sizeSmall: classes.sizeSmall,
    }}
  />
));
